module.exports = __webpack_public_path__ + "img/money.8cb58d86.svg";